// removed by extract-text-webpack-plugin
module.exports = {"statusColumn":"statusIcons__statusColumn__2U8qC","statusLabel":"statusIcons__statusLabel__3aE1r","color_green":"statusIcons__color_green__3cAW-","comment_value":"statusIcons__comment_value__2IB0E","comment_icon":"statusIcons__comment_icon__1wPQ2","actions_icon":"statusIcons__actions_icon__33ptP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TransactionList/Columns/StatusIcons/statusIcons.css
// module id = 1658
// module chunks = 0